const initState = {
  billData: {},
  token: "",
  isLogin: false,
  loading: false,
  dailyUsage: {},
  invoiceList: [],

  manageList: [],

  paymentList: [],
  ticketList: [],
  InvoList: [],

  //TOPUP
  dataTopupList: {},

  //HELP
  ticketTemplate: {},
  teamUsers: [],
  ticketById: {},
  transactionList:[],
};

export default initState;
